
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/photo-credits",
      function () {
        return require("private-next-pages/photo-credits.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/photo-credits"])
      });
    }
  